import { observer, inject } from "mobx-react";
import { useState, useEffect } from "react";
import LoadingContainer from "../layouts/LoadingContainer";
import RepairPagesList from "../components/RepairPagesList";
import NoteMessageContent from "../components/NoteMessageContent";
import { Box, InnerBox } from "../components/Common";
import RepairPagesMessageContent from "../components/RepairPagesMessageContent";
import { useLocation } from "react-router-dom";
import { useMobile } from "../utils/mobile";

const RepairPages = ({ userStore, tenantsStore, repairPagesStore, bedek }) => {
  const location = useLocation();
  const [isLoading, setLoading] = useState(false);
  const [selectedRepairPage, setSelectedRepairPage] = useState();
  const [repairPages, setRepairPages] = useState([]);
  const isMobile = useMobile();

  const getRepairPages = async () => {
    const data = {
      CUST: userStore.userDetails.CUST,
      MAINCUST: userStore.userDetails.MAINCUST,
      MAINENV: userStore.userDetails.MAINENV,
      CONTNAME: tenantsStore.selectedContract?.CONTNAME,
      SPACENAME:
        tenantsStore.selectedContract?.SPACENAME ||
        tenantsStore.selectedSiteSpace?.SPACENAME ||
        location?.state?.SPACENAME,
      CONT: tenantsStore.selectedContract?.CONT,
      CUSTNAME: tenantsStore.selectedContract?.CUSTNAME,
      SITEID:
        tenantsStore.selectedContract?.SITEID ||
        tenantsStore.selectedSiteSpace?.SITEID ||
        location?.state?.SITEID,
      DNAME: tenantsStore.selectedContract?.DNAME,
      ENV: tenantsStore.selectedContract?.DNAME,
    };
    setLoading(true);
    await userStore.getApplicationAttributes(data);
    const applies = !bedek
      ? (await tenantsStore.getSaleContractApplies(data)) || []
      : [];
    const repairPages =
      tenantsStore.selectedSiteSpace?.ISONLYCONTSALE !== "Y"
        ? (await repairPagesStore.getRepairPages(data)) || []
        : [];
    const allApplies = [...repairPages, ...applies];
    setSelectedRepairPage(allApplies.length > 0 ? allApplies[0] : null);

    setRepairPages(allApplies);
    await repairPagesStore.getStatuses(data);

    setLoading(false);
  };

  useEffect(() => {
    getRepairPages();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantsStore.selectedSiteSpace]);

  return (
    <>
      <LoadingContainer isLoading={isLoading}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            margin: isMobile ? 0 : 25,
            gap: 30,
          }}
        >
          <Box
            flexBasis={isMobile ? 100 : 30}
            style={{
              height: isMobile ? "100vh" : "86vh",
              borderRadius: isMobile && 0,
            }}
            isMobile={isMobile}
          >
            <InnerBox
              noPadding={isMobile}
              isMobile={isMobile}
              style={{ borderRadius: 18 }}
            >
              <RepairPagesList
                selectedRepairPage={selectedRepairPage}
                repairPages={repairPages}
                isMobile={isMobile}
                setSelectedRepairPage={setSelectedRepairPage}
              />
            </InnerBox>
          </Box>
          {!isMobile && (
            <Box flexBasis={70} style={{ height: "86vh" }} width={"100%"}>
              <InnerBox
                style={{ padding: 0, overflow: "auto", borderRadius: 18 }}
              >
                {!!selectedRepairPage && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                      alignItems: "start",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        flex: 1,
                      }}
                    >
                      {selectedRepairPage.REPAIRNAME ? (
                        <RepairPagesMessageContent
                          repairPage={selectedRepairPage}
                          bedek={bedek}
                        />
                      ) : (
                        <NoteMessageContent
                          note={selectedRepairPage}
                          isMobile={isMobile}
                        />
                      )}
                    </div>
                  </div>
                )}
              </InnerBox>
            </Box>
          )}
        </div>
      </LoadingContainer>
    </>
  );
};

export default inject(
  "userStore",
  "tenantsStore",
  "repairPagesStore"
)(observer(RepairPages));
